import { render, staticRenderFns } from "./shwv1.vue?vue&type=template&id=3bf7e227&scoped=true"
import script from "./shwv1.vue?vue&type=script&lang=js"
export * from "./shwv1.vue?vue&type=script&lang=js"
import style0 from "./shwv1.vue?vue&type=style&index=0&id=3bf7e227&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf7e227",
  null
  
)

export default component.exports